// extracted by mini-css-extract-plugin
module.exports = {"table":"RecipientsTable_table__3ACW4","tableHeadCell":"RecipientsTable_tableHeadCell__1Zv53"};